export default __webpack_public_path__ + "static/media/BGSplashMobile.35ffbdbf.webp";